/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DspDebugAudioFenceLobeFragment = { id: string, features: { lobe: { status: Types.LobeStatus, position: { xPosition: number, yPosition: number, zPosition: number } } | null }, description: { index: number, constraints: { lobe: { position: { xPosition: { range: { max: number, min: number, step: number } }, yPosition: { range: { max: number, min: number, step: number } } } } | null } } };

export type DeviceCoverageDeviceDebugFragment = { id: string, isDeviceNode: 'Device', description: { features: { dspDebugAudioFenceLobes: { supported: boolean } } }, features: { dspDebugAudioFenceLobes: { dspDebugAudioFenceLobes: Array<DspDebugAudioFenceLobeFragment> } | null } };

export type DeviceCoverageDeviceDebugUpdateFragment = { id: string, features: { virtualAcousticBoundary: { enabled: boolean, sensitivity: number } | null } | {} };

export type GetCoverageDeviceDebugQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetCoverageDeviceDebugQueryOpResult = { node: DeviceCoverageDeviceDebugFragment | {} };

export type CoverageDeviceDebugSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type CoverageDeviceDebugSubscriptionOpResult = { nodeChanges: DeviceCoverageDeviceDebugFragment | DeviceCoverageDeviceDebugUpdateFragment | { id: string, fragmentId: string, features: { lobe: { position: { xPosition: number, yPosition: number, zPosition: number } } | null } } | {} };

export type DebugAudioFenceLobeSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type DebugAudioFenceLobeSubscriptionOpResult = { nodeChanges: { id: string, features: { lobe: { status: Types.LobeStatus, position: { xPosition: number, yPosition: number, zPosition: number } } | null } } | {} };

export const DspDebugAudioFenceLobeFragment = gql`
    fragment DspDebugAudioFenceLobeFragment on DspDebugAudioFenceLobe {
  id
  features {
    lobe {
      position {
        xPosition
        yPosition
        zPosition
      }
      status
    }
  }
  description {
    constraints {
      lobe {
        position {
          xPosition {
            range {
              max
              min
              step
            }
          }
          yPosition {
            range {
              max
              min
              step
            }
          }
        }
      }
    }
    index
  }
}
    `;
export const DeviceCoverageDeviceDebugFragment = gql`
    fragment DeviceCoverageDeviceDebugFragment on Device {
  isDeviceNode: __typename
  id
  description {
    features {
      dspDebugAudioFenceLobes {
        supported
      }
    }
  }
  features {
    dspDebugAudioFenceLobes {
      dspDebugAudioFenceLobes {
        ...DspDebugAudioFenceLobeFragment
      }
    }
  }
}
    ${DspDebugAudioFenceLobeFragment}`;
export const DeviceCoverageDeviceDebugUpdateFragment = gql`
    fragment DeviceCoverageDeviceDebugUpdateFragment on DeviceChange {
  id
  features {
    ... on DeviceVirtualAcousticBoundaryChange {
      virtualAcousticBoundary {
        enabled
        sensitivity
      }
    }
  }
}
    `;
export const GetCoverageDeviceDebugQueryDocument = gql`
    query GetCoverageDeviceDebugQuery($id: ID!) {
  node(id: $id) {
    ...DeviceCoverageDeviceDebugFragment
  }
}
    ${DeviceCoverageDeviceDebugFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCoverageDeviceDebugQueryGQL extends Apollo.Query<GetCoverageDeviceDebugQueryOpResult, GetCoverageDeviceDebugQueryVariables> {
    override document = GetCoverageDeviceDebugQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CoverageDeviceDebugSubscriptionDocument = gql`
    subscription CoverageDeviceDebugSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...DeviceCoverageDeviceDebugFragment
    ...DeviceCoverageDeviceDebugUpdateFragment
    ... on DspDebugAudioFenceLobeChange {
      id
      fragmentId
      features {
        ... on DspDebugAudioFenceLobeCoreChange {
          lobe {
            position {
              xPosition
              yPosition
              zPosition
            }
          }
        }
      }
    }
  }
}
    ${DeviceCoverageDeviceDebugFragment}
${DeviceCoverageDeviceDebugUpdateFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CoverageDeviceDebugSubscriptionGQL extends Apollo.Subscription<CoverageDeviceDebugSubscriptionOpResult, CoverageDeviceDebugSubscriptionVariables> {
    override document = CoverageDeviceDebugSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DebugAudioFenceLobeSubscriptionDocument = gql`
    subscription DebugAudioFenceLobeSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ... on DspDebugAudioFenceLobeChange {
      id
      features {
        ... on DspDebugAudioFenceLobeCoreChange {
          lobe {
            position {
              xPosition
              yPosition
              zPosition
            }
            status
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DebugAudioFenceLobeSubscriptionGQL extends Apollo.Subscription<DebugAudioFenceLobeSubscriptionOpResult, DebugAudioFenceLobeSubscriptionVariables> {
    override document = DebugAudioFenceLobeSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }